import "./EmailFoundStep.less";

import React, { Component } from "react";
import { translate } from "react-i18next";

import StepContainer from "../StepContainer/StepContainer";
import ScoodleAccountTile from "../../ScoodleAccountTile/ScoodleAccountTile";
import Password from "../../Password/Password";
import config from "../../../config";
import queryString from "query-string";
import $ from "jquery";

class EmailFoundStep extends Component {
	state = {
		password: ""
	};

	constructor() {
		super();

		const currentQuery = queryString.parse(window.location.search);
        const id_token = config.user ? config.user.id_token : null;

		$.ajax({
			url: config.identityServer.baseUrl + "/Portal/SetPasswordGetEmailAuth",
			data: {
				reference: currentQuery.reference,
				validate: currentQuery.validate,
                clientId: currentQuery.clientId || config.identityServer.clientId
			},
            headers: {
                'Authorization': 'Bearer ' + id_token
            },
			success: result => {
				if (result.success) {
					this.setState({ 
						email: result.email,
						isConfirm: result.isConfirm
					 });
				}
				else {
					window.location = '/';
				}
			}
		})
		.fail(() => {
			window.location = '/';
		});
	}

	render() {
		const t = this.props.t;
		
		if (!this.state.email) return <div/>;

		return (
			<StepContainer>
				<div className="third-party-email">
					<h1>{t("logIn")}</h1>
					<ScoodleAccountTile email={this.state.email} />
					<p className="description">{t("description")}</p>
					<Password onChange={this.handlePasswordChange} />					
					{this.state.showError && <p className="error">{this.state.errorMessage}</p>}
					<button className="primarybtn" onClick={this.handleContinueButtonClick}>{t("continueButton")}</button>
				</div>
			</StepContainer>
		);
	}

	handlePasswordChange = password => {
		this.setState({ password });
	};

	handleContinueButtonClick = e => {
		const t = this.props.t;

		e.preventDefault();

		if ((this.state.password || '').trim().length === 0) {
			this.setState({ showError: true, errorMessage: t('passwordRequired') });
			return;
		}		
		
		this.setState({ showError: false, errorMessage: '' });
		
		const currentQuery = queryString.parse(window.location.search);
		const returnUrl = currentQuery.returnUrl;
        const id_token = config.user ? config.user.id_token : null;

		if (!this.state.isConfirm) {
			$.ajax({
				url: config.identityServer.baseUrl + "/Portal/SetPasswordConfirmAuth",
				method: 'POST',
				data: {
					password: this.state.password,
					clientId: currentQuery.clientId || config.identityServer.clientId,
					culture: config.language + "-BE"
				},
                headers: {
                    'Authorization': 'Bearer ' + id_token
                },
				success: result => {
					if (!result.success) {
						this.setState({ showError: true, errorMessage: t(result.errorCode) });
					}
					else {				
						window.location = returnUrl || '/';
					}
				}
			})
			.fail(() => {
				this.setState({ showError: true, errorMessage: t('unexpectedError') });
			});
		}
		else {
			$.post(`${config.identityServer.baseUrl}/Portal/ForgottenPasswordValidate`, {
				reference: currentQuery.reference,
				validate: currentQuery.validate,
				password: this.state.password,
				clientId: currentQuery.clientId || config.identityServer.clientId,
				culture: config.language + "-BE",
				returnUrl: returnUrl
			},
			result => {
				if (!result.success) {
					this.setState({ showError: true, errorMessage: t(result.errorCode) });
				}
				else {				
					const url = `${config.identityServer.baseUrl}/Portal/ForgottenPasswordConfirm`
	
					$($('<form method="POST" />').attr('action', url))
						.append($('<input type="hidden" name="reference">').val(currentQuery.reference))
						.append($('<input type="hidden" name="validate">').val(currentQuery.validate))
						.append($('<input type="hidden" name="password">').val(this.state.password))
						.append($('<input type="hidden" name="clientId">').val(currentQuery.clientId || config.identityServer.clientId))
						.append($('<input type="hidden" name="culture">').val(config.language + "-BE"))
						.append($('<input type="hidden" name="returnUrl">').val(currentQuery.returnUrl))
						.appendTo(document.body)
						.submit();
				}
			})
			.fail(() => {
				this.setState({ showError: true, errorMessage: t('unexpectedError') });
			});
		}
	};
}

export default translate("emailFound")(EmailFoundStep);



// WEBPACK FOOTER //
// ./src/components/Steps/EmailFoundStep/EmailFoundStep.js